/* 
File: src/components/AddressBanner/AddressBanner.js
Author: Stanley Chen
Details: Javascript for AddressBanner Component. This is a small red banner containing the location of Kiku.
*/

import React from 'react';
import './AddressBanner.css';

const AddressBanner = () => {
  return (
    <div className="address-banner">
      <div className="address-container">
        <div className="address-content">
          <div className="location-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="22" height="22" fill="currentColor">
              <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/>
            </svg>
          </div>
          <span className="address-text">417 S Ridge Ave, Middletown, DE 19709</span>
        </div>
      </div>
    </div>
  );
};

export default AddressBanner;